import React from 'react';
import BaseSwiper from '@src/components/swiper/base-swiper';
import wrapStore from '@src/utils/wrap-store';
import PageSwiperStore from './store';

const styles = require('./index.less');

/**
 * 全屏滚动-组件
 *
 * 基于BaseSwiper组件实现
 * 使用方式:
 *
 * <PageSwiper>
 *   <div>Slide 1</div>
 *   <div>Slide 2</div>
 *   <div>Slide 3</div>
 *   <div>Slide 4</div>
 *   <div>Slide 5</div>
 * </PageSwiper>
 *
 * 目前默认使用 "fade"的切换效果,
 * 如果需要使用其他切换效果,例如是slide位移的切换效果,只需要在new pageSwiperStore({effectModal: pageSwiperEffect.NORMAL}) 传递需要的mode即可
 * 目前支持的mode有:NORMAL、FADE
 *
 * @param children
 * @param store {PageSwiperStore}
 * @returns {JSX.Element}
 * @constructor
 */
const PageSwiper = ({ children, store }) => {
  store.use();
  return (
    <div className={styles.root}>
      <BaseSwiper store={store.baseSwiperStore}>{children}</BaseSwiper>
    </div>
  );
};

export default wrapStore(PageSwiper, PageSwiperStore);
